import { render } from "./Lecture.vue?vue&type=template&id=77b4832f&scoped=true"
import script from "./Lecture.vue?vue&type=script&lang=js"
export * from "./Lecture.vue?vue&type=script&lang=js"

import "./Lecture.vue?vue&type=style&index=0&id=77b4832f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77b4832f"

export default script